<template>
  <div class="cursor-pointer" :class="{disabled: disabled, 'inline-flex mr-4': inline}">
    <input :id="cbId"
           class="form-radio h-5 w-5 text-gray-800 transition duration-150 ease-in-out cursor-pointer"
           type="radio"
           :disabled="disabled"
           :value="label"
           v-model="model"/>
    <label :for="cbId" class="ml-2 cursor-pointer">
      <span class="block text-sm leading-5 font-medium text-gray-700">
        <slot></slot>
      </span>
    </label>
  </div>
</template>
<script>
  export default {
    name: 'base-radio',
    props: {
      label: {
        type: [String, Number],
        description: 'Radio label'
      },
      disabled: {
        type: Boolean,
        description: 'Whether radio is disabled'
      },
      value: {
        type: [String, Boolean],
        description: 'Radio value'
      },
      inline: {
        type: Boolean,
        description: 'Whether radio is inline'
      }
    },
    data () {
      return {
        cbId: ''
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
    },
    created () {
      this.cbId = Math.random().toString(16).slice(2)
    }
  }
</script>
